import { system } from "styled-system";
import { transformGridValue } from "./transforms";
var gridColumnGapConfig = {
  property: "gridColumnGap",
  scale: "space",
  transform: function transform(value, scale) {
    return transformGridValue(value, scale);
  }
};
export var gridColumnGap = system({
  // dynamic grid units
  gridColumnGap: gridColumnGapConfig
});
export default gridColumnGap;